// extracted by mini-css-extract-plugin
export var container = "_dz-0";
export var content = "_dz-3";
export var customerTitle = "_dz-4";
export var empty = "_dz-5";
export var gray = "_dz-6";
export var header = "_dz-7";
export var info = "_dz-8";
export var loading = "_dz-2";
export var loadingCard = "_dz-9";
export var oneLine = "_dz-a";
export var personName = "_dz-e";
export var pillContainer = "_dz-b";
export var selected = "_dz-1";
export var text = "_dz-c";
export var twoLines = "_dz-d";
export var unread = "_dz-f";
export var unreadIndicator = "_dz-g";